import Icon from '../components/Icon.vue'

Icon.register({
  'drum-steelpan': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M288 32c159.1 0 288 57.3 288 128v192c0 70.7-128.9 128-288 128s-288-57.3-288-128v-192c0-70.7 128.9-128 288-128zM205 190.4c5.1-19.1 2.5-39-7.4-56.1l-25.6-44.3c-73.9 13.6-124 39.9-124 70 0 30.8 52.2 57.5 128.7 70.8 13.8-9.9 23.9-23.9 28.3-40.5zM288 240c21.1 0 41.4-1 60.9-2.7-8.1-26.1-32.1-45.3-60.9-45.3s-52.8 19.2-60.9 45.3c19.5 1.7 39.8 2.7 60.9 2.7zM352 96v-13c-20.4-1.9-41.8-3-64-3s-43.6 1.1-64 3v13c0 35.3 28.7 64 64 64s64-28.7 64-64zM398.9 230.9c76.7-13.4 129.1-40.1 129.1-70.9 0-30.2-50.3-56.5-124.4-70.1l-25.6 44.4c-9.9 17.1-12.5 37-7.4 56 4.5 16.6 14.6 30.6 28.4 40.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/drum-steelpan.js
// module id = 1288
// module chunks = 0